import { useParams } from 'react-router-dom'

import useFetchMachine from '@/gf/hooks/useFetchMachine'

import Page from '@/gf/components/Page'
import Layout from '@/gf/components/Layout'
import AccountMachineDetails from '@/gf/components/AccountMachineDetails'
import Frame from '../components/Frame'
import NotFound from './NotFound'

const MachineDetails = () => {
  const { machineId: id } = useParams<{ machineId: string }>() as { machineId: string }
  const result = useFetchMachine({ variables: { id } })
  const machine = result.data?.machine

  const reload = () => {
    result.refetch({ id })
  }

  if (machine === null) return <NotFound />

  return (
    <Frame>
      <Page title="Machine Details">
        <Layout>
          <Layout.Section type="full">
            <AccountMachineDetails machine={machine} onEdit={reload} />
          </Layout.Section>
        </Layout>
      </Page>
    </Frame>
  )
}

export default MachineDetails
